export default "__VITE_ASSET__DktjAWMF__"